
























































import {Component, Prop, Vue} from 'vue-property-decorator'
import {$, ID, successAndPush} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import _ from 'lodash'
import AreaDeRisco from '@/model/resource/AreaDeRisco'

const metaInfo = () => ({
  title: $.t('view.persist.riskAreaPersist.title'),
})

@Component({
  metaInfo,
})
export default class RiskAreaPersistView extends Vue {
  @Prop({type: [String, Number]}) id?: ID

  AppConfig = AppConfig

  listToPersist: AreaDeRisco[] = []

  persistThrottled = _.throttle(() => this.persist(), 7000)

  created() {
    this.$set(this.listToPersist, 0, new AreaDeRisco())
  }

  async mounted() {
    if (this.id) await this.listToPersist[0].getAreaDeRisco(this.id)
    $.await.done('getAreaDeRisco')
  }

  addItem() {
    this.listToPersist.push(new AreaDeRisco())
  }

  removeItem(item: AreaDeRisco) {
    const index = this.listToPersist.indexOf(item)
    if (index > -1) {
      this.listToPersist.splice(index, 1)
      this.$forceUpdate()
    }
  }

  async persist() {
    await AreaDeRisco.persistLoteAreaDeRisco(this.listToPersist)
    successAndPush('system.success.persist', '/manage/risk-area/list')
  }

}
